export class ModalConfig {
    constructor(config: ModalConfigDef) {}
}

export interface ModalConfigDef {
    id?: number,
    width?: number,
    height?: number,
}